<template>
<v-toolbar color="blue darken-1" fixed dark app>
    <v-toolbar-title class="ml-0 pl-3" style="margin-left:-20px!important">
        <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
        <span>{{showTitleText}}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-text-field style="margin-top:7px" full-width v-if="showToolbarSearch" flat solo-inverted label="Search" class="hidden-sm-and-down">
    </v-text-field>
    <v-spacer></v-spacer>
    <!-- <v-btn icon href="https://github.com/tookit/vue-material-admin">
        <v-icon>fa fa-github</v-icon>
    </v-btn> -->
    <!-- <v-btn icon @click="toggleToolbarSearch()">
        <v-icon>search</v-icon>
    </v-btn> -->
    <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
    </v-btn>
    <!-- <v-menu offset-y origin="center center" class="elelvation-1" :nudge-bottom="14" transition="scale-transition">
        <v-btn icon flat slot="activator">
            <v-badge color="red" overlap>
                <span slot="badge">3</span>
                <v-icon medium>notifications</v-icon>
            </v-badge>
        </v-btn>
        <notification-list></notification-list>
    </v-menu> -->
    <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon flat slot="activator">
            <v-badge color="grey" overlap>
                <span class="badge-language" slot="badge">{{ languageSelected }}</span>
                <v-icon medium>language</v-icon>
            </v-badge>
        </v-btn>
        <v-list class="pa-0">
            <v-list-tile v-for="lang in langList" @click="switchLanguage(lang.code)" ripple="ripple" :key="lang.code">
                <v-list-tile-content :class="{'primary--text': lang.code == languageSelected}">{{ lang.label }}</v-list-tile-content>
            </v-list-tile>
        </v-list>
    </v-menu>
    <v-btn flat>{{ userDetail.name }}({{ userDetail.code }})</v-btn>
    <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
            <v-avatar size="30px">
                <img src="/static/avatar/n1.jpeg" alt="avatar"/>
            </v-avatar>
        </v-btn>
        
        <v-list class="pa-0">
            <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
                <v-list-tile-action v-if="item.icon">
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
            <v-list-tile @click="logOut">
                <v-list-tile-action>
                    <v-icon>fullscreen_exit</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title>Logout</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
         
    </v-menu>
</v-toolbar>
</template>

<script>
import lang from "@/api/language"
import NotificationList from '@/components/widgets/list/NotificationList';
import Util from '@/util';
import { mapGetters, mapActions } from 'vuex'
import authen from "@/store/modules/authen";

export default {
    name: 'app-toolbar',
    components: {
        NotificationList
    },
    watch: {
        logIn() {
            if (!this.logIn) {

            }
        }
    },
    data: () => ({
        langList: lang,
        showToolbarSearch: false,
        logIn: true,
        items: [{
                icon: 'account_circle',
                href: '#',
                title: 'Profile',
                click: (e) => {
                    console.log(e);
                }
            },
            {
                icon: 'settings',
                href: '#',
                title: 'Settings',
                click: (e) => {
                    
                }
            }
        ],
    }),
    computed: {
         ...mapGetters('app', ['showTitleText']),
         ...mapGetters("app", ["languageSelected"]),
         ...mapGetters("authen", ["userCode"]),
         ...mapGetters("authen", ["userDetail"]),
        toolbarColor() {
            return this.$vuetify.options.extra.mainNav;
        },
        languageLabel(){
            let tmpLang = this.langList.find((lang) => {
                return lang.code == this.languageSelected
                })
            return tmpLang.label;
        }
    },
    methods: {   
        ...mapActions("app", ["setLanguage"]),
        switchLanguage(lang){
            this.setLanguage(lang);
            this.$i18n.locale = lang
            localStorage.setItem("lang", lang)
        },     
        toggleToolbarSearch() {
            this.showToolbarSearch = !this.showToolbarSearch
        },
        handleDrawerToggle() {
            window.getApp.$emit('APP_DRAWER_TOGGLED');
        },
        handleFullScreen() {
            Util.toggleFullScreen();
        },
        logOut() {            
            localStorage.removeItem("_token")
            this.$router.push('/login');
        }
    }
}
</script>

<style  scoped>
    .badge-language{
        font-size: 10px !important;
    }
</style>


